import { Typography } from '@pankod/refine-antd';
import { IAddress } from 'interfaces';

const { Title, Text } = Typography;

type AddressProps = Partial<Omit<IAddress, 'id'>>;

export const AddressShow: React.FC<AddressProps> = (props) => {
  return (
    <>
      <Title level={5}>Street</Title>
      <Text>{props.street}</Text>
      <Title level={5}>Area</Title>
      <Text>{props.area}</Text>
      <Title level={5}>City</Title>
      <Text>{props.city}</Text>
      <Title level={5}>Country</Title>
      <Text>{props.country}</Text>
      <Title level={5}>Zip</Title>
      <Text>{props.zip}</Text>
    </>
  );
};
